<p>import-products works!</p>
